import { render, staticRenderFns } from "./NewDoubleGood.vue?vue&type=template&id=8d16a790&scoped=true"
import script from "./NewDoubleGood.vue?vue&type=script&lang=js"
export * from "./NewDoubleGood.vue?vue&type=script&lang=js"
import style0 from "./NewDoubleGood.vue?vue&type=style&index=0&id=8d16a790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d16a790",
  null
  
)

export default component.exports